import { useSelector } from 'react-redux';
import {
  getDistanceUnitSelector,
  getElevationUnitSelector,
} from 'store/Common/selectors';
import { Tooltip } from 'antd';

import { S } from './RouteCard.styles';
import { RouteCardProps } from './RouteCard.inteface';
import { FormattedMessage } from 'react-intl';
import { BaseSwitch } from 'controls/BaseSwitch/BaseSwitch';


export const RouteCard: React.FC<RouteCardProps> = ({
  route,
  onRouteChanged
}) => {
  const actualDistanceUnit = useSelector(getDistanceUnitSelector);
  const actualElevationUnit = useSelector(getElevationUnitSelector);

  const handleChange = (checked: boolean) => {
      if (onRouteChanged){
        onRouteChanged(route, checked)
      }
  };

  return (
    <S.Container>
      <S.RouteInfo>
        <Tooltip placement="top" title={route.routeName}>
          <S.Title>{route.routeName}</S.Title>
        </Tooltip>
        <S.ShortInfo>
          {(route.routeLength || route.routeLength === 0) && (
            <S.LiBase>
              {(route.routeLength / actualDistanceUnit.valueInMeters).toFixed(1)}{' '}
              <FormattedMessage id={actualDistanceUnit.name}/>
            </S.LiBase>
          )}
          <br/>
          <S.Li>
            <FormattedMessage id="total_asc"/>:{' '}
            {(route.totalAscent / actualElevationUnit.valueInMeters).toFixed(0)}{' '}
            <FormattedMessage id={actualElevationUnit.shortName}/>
          </S.Li>
          <S.Li>
            <FormattedMessage id="total_desc"/>:{' '}
            {(route.totalDescent / actualElevationUnit.valueInMeters).toFixed(0)}{' '}
            <FormattedMessage id={actualElevationUnit.shortName}/>
          </S.Li>
        </S.ShortInfo>
        {/* <S.Location>{name}</S.Location> */}
      </S.RouteInfo>
      <BaseSwitch
        onChange={handleChange}
        checked={route.isEnabled}
      />
    </S.Container>
  );
};
